import { RyderEnvironment } from "@redotech/redo-model/integration/ryder/types";
import * as z from "zod/v4";

export const ryderIntegrationSchema = z.object({
  environment: z.nativeEnum(RyderEnvironment),
  webhooksSubscribed: z.boolean(),
  createReturnsEnabled: z.boolean(),
  processReturnsEnabled: z.boolean(),
  forceBlindReturns: z.boolean(),
  allowBlindReturnsFallback: z.boolean(),
});

export const getRyderIntegration = {
  name: "getRyderIntegration" as const,
  input: z.object({}),
  output: z.object({ ryderIntegration: ryderIntegrationSchema.nullable() }),
};
